export const ADD_RECOMMENDATION = '@@hfty-recommendations/ADD_RECOMMENDATION'
export const EDIT_RECOMMENDATION = '@@hfty-recommendations/EDIT_RECOMMENDATION'
export const REMOVE_RECOMMENDATIONS = '@@hfty-recommendations/REMOVE_RECOMMENDATIONS'
export const FETCH_HEFTY_CROPS = '@@hfty-recommendations/FETCH_HEFTY_CROPS'
export const FETCH_RECOMMENDATIONS = '@@hfty-recommendations/FETCH_RECOMMENDATIONS'
export const FETCH_RECOMMENDATION_BY_ID = '@@hfty-recommendations/FETCH_RECOMMENDATION_BY_ID'
